import React, { useEffect, useState } from "react";

const testimonials = [
  {
    image: "images/resources/testi-1-2.jpg",
    name: "Mr. Ajay Patil",
    text: "Om Sai Cab Service provided a very smooth and safe journey from Pune to Mumbai. The driver was polite and punctual.",
  },
  {
    image: "images/resources/testi-1-5.jpg",
    name: "Mr. Sagar Deshmukh",
    text: "Excellent outstation cab service. Clean car, professional driver, and very comfortable ride experience.",
  },
  {
    image: "images/resources/testi-1-1.jpg",
    name: "Miss. Pooja Kulkarni",
    text: "Very affordable and reliable cab service. Booking was easy and the ride was very comfortable throughout.",
  },
  {
    image: "images/resources/testi-1-4.jpg",
    name: "Miss. Sneha Joshi",
    text: "Great service for family travel. The driver was very helpful and the car was well maintained.",
  },
  {
    image: "images/resources/testi-1-3.jpg",
    name: "Mr. Rohit Shinde",
    text: "I used Om Sai Cab Service for airport drop. The experience was hassle-free and on time.",
  },
  {
    image: "images/resources/testi-1-6.jpg",
    name: "Mr. Nilesh Jadhav",
    text: "Very professional service with reasonable rates. I highly recommend Om Sai Cab for local and outstation trips.",
  },
];

const TestimonialsAbout = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <section className="testimonials-style-one">
      <div className="container">
        {/* Section Title */}
        <div className="block-title text-center">
          <div className="dot-line"></div>
          <p className="light">What our clients say</p>
          <h2 className="light">Testimonials</h2>
        </div>

        {/* Pager Images */}
        <div className="testimonials-one-pager">
          {testimonials.map((item, index) => (
            <button
              key={index}
              className={`pager-item ${
                currentSlide === index ? "active" : ""
              }`}
              onClick={() => setCurrentSlide(index)}
              style={{
                border: "none",
                background: "transparent",
                padding: "0",
                margin: "0 5px",
                cursor: "pointer",
              }}
            >
              {/* <img
                src={item.image || "images/default-user.jpg"}
                alt={item.name}
              /> */}
            </button>
          ))}
        </div>

        {/* Testimonial Content */}
        <div className="single-testimonial-one text-center">
          <p>{testimonials[currentSlide].text}</p>
          <h3>{testimonials[currentSlide].name}</h3>
        </div>
      </div>

      {/* Slider Buttons */}
      <div className="testimonials-one-slider-btn">
        <span className="carousel-btn left-btn" onClick={prevSlide}>
          <i className="fa fa-chevron-left"></i>
        </span>

        <span className="carousel-btn right-btn" onClick={nextSlide}>
          <i className="fa fa-chevron-right"></i>
        </span>
      </div>
    </section>
  );
};

export default TestimonialsAbout;